import { defineComponent as B, computed as E, ref as u, reactive as $, watch as d, onMounted as j, onBeforeUnmount as x, createElementBlock as f, openBlock as v, Fragment as _, createElementVNode as r, createVNode as q, unref as A, normalizeStyle as N, createCommentVNode as P, withModifiers as w, toDisplayString as I, renderList as z, normalizeClass as H } from "vue";
import { ScalarIconTextAlignLeft as L } from "@scalar/icons";
import { EditorClasses as M } from "@scalar-org/css";
const D = { class: "header" }, F = { class: "container" }, R = {
  key: 0,
  class: "level-1"
}, U = ["id"], Y = ["href", "onClick"], G = "__", W = /* @__PURE__ */ B({
  __name: "TableOfContents",
  props: {
    headings: {},
    pageTitle: {}
  },
  setup(b) {
    const h = b, m = E(
      () => Object.values(h.headings || {}).filter((e) => e.level === 1 || e.level === 2 || e.level === 3).map((e) => e.slug)
    ), k = (e) => e.split(G).length, o = u(""), a = u(""), l = $({}), i = E(
      () => Object.values(l).sort((e, t) => e.order - t.order)
    ), g = u([]), p = u(0);
    function C() {
      Object.keys(l).forEach((e) => {
        m.value.includes(e) || delete l[e];
      }), m.value.forEach((e, t) => {
        l[e] = {
          id: e,
          inView: l[e]?.inView ?? !1,
          order: t
        };
      });
    }
    d(m, () => C(), { immediate: !0, deep: !0 });
    const O = (e) => {
      e.forEach((t) => {
        if (l[t.target.id] && (l[t.target.id].inView = t.isIntersecting), a.value = t.target.id, !t.isIntersecting && t.target.getBoundingClientRect().top >= window.innerHeight * 0.2 && Object.values(l).every((c) => !c.inView)) {
          const c = i.value.findIndex(
            (T) => T.id === t.target.id
          );
          c >= 1 && (a.value = i.value[c - 1].id);
        }
      });
    };
    d(
      [a, i],
      () => {
        const e = i.value.find((t) => t.inView);
        if (e) {
          o.value = e.id;
          return;
        }
        if (a.value) {
          o.value = a.value;
          return;
        }
      },
      { immediate: !0, deep: !0 }
    );
    let s;
    function y() {
      s && s.disconnect(), document.querySelectorAll(
        '[data-scalar-type="heading"][data-level="1"], [data-scalar-type="heading"][data-level="2"], [data-scalar-type="heading"][data-level="3"]'
      ).forEach((t) => s?.observe(t));
    }
    j(() => {
      s = new IntersectionObserver(O, {
        // threshold: 1,
        // rootMargin: '-20%',
      }), y();
    }), x(() => {
      s?.disconnect();
    }), d(
      () => Object.keys(h.headings || {}),
      () => {
        g.value = [], y();
      }
    );
    function S(e) {
      o.value = e.slug, window.location.replace(`#${e.slug}`), document.getElementById(e.slug)?.scrollIntoView();
    }
    function V() {
      document.querySelector(`.${M.PageTitle} h1`)?.scrollIntoView();
    }
    return d(o, () => {
      const e = g.value.find(
        (t) => t.querySelector(".anchor")?.getAttribute("href") === `#${o.value}`
      );
      e && (p.value = e.offsetTop);
    }), (e, t) => (v(), f(_, null, [
      r("div", D, [
        q(A(L)),
        t[0] || (t[0] = r("h4", null, "On This Page", -1))
      ]),
      r("div", F, [
        r("div", {
          class: "outline-marker",
          style: N({
            transform: `translateY(${p.value}px)`
          })
        }, null, 4),
        r("ul", null, [
          Object.keys(e.headings || {}).length === 0 ? (v(), f("li", R, [
            r("a", {
              class: "anchor",
              href: "#",
              onClick: w(V, ["prevent"])
            }, I(e.pageTitle), 1)
          ])) : P("", !0),
          (v(!0), f(_, null, z(e.headings, (n) => (v(), f("li", {
            id: n.uid,
            key: n.uid,
            ref_for: !0,
            ref_key: "tocItems",
            ref: g,
            class: H([
              `level-${n.level}`,
              `toc-indent-${k(n.slug)}`,
              { active: o.value === n.slug }
            ])
          }, [
            r("a", {
              class: "anchor",
              href: `#${n.slug}`,
              onClick: w(() => S(n), ["prevent"])
            }, I(n.name), 9, Y)
          ], 10, U))), 128))
        ])
      ])
    ], 64));
  }
});
export {
  W as default
};
